import { For } from 'solid-js'
import { activeTool, useTool, type ToolId } from '../editor.ts'
import { Icon, type IconName } from './Icon.tsx'

interface Entry {
  id: ToolId
  icon: IconName
  label: string
  key: string
}

const entries: Entry[] = [
  { id: 'select', icon: 'select', label: 'Select', key: 'V' },
  { id: 'pan', icon: 'hand', label: 'Pan', key: 'H' },
  { id: 'rect', icon: 'rect', label: 'Rectangle', key: 'R' },
  { id: 'ellipse', icon: 'ellipse', label: 'Ellipse', key: 'O' },
  { id: 'line', icon: 'line', label: 'Line', key: 'L' },
  { id: 'pen', icon: 'pen', label: 'Draw', key: 'P' },
  { id: 'text', icon: 'text', label: 'Text', key: 'T' },
]

export function Toolbar() {
  return (
    <div class="toolbar" role="toolbar" aria-label="Tools">
      <For each={entries}>
        {(e) => (
          <button
            type="button"
            class="tool"
            classList={{ active: activeTool() === e.id }}
            title={`${e.label} (${e.key})`}
            aria-label={e.label}
            aria-pressed={activeTool() === e.id}
            onClick={() => useTool(e.id)}
          >
            <Icon name={e.icon} />
          </button>
        )}
      </For>
    </div>
  )
}
